import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  staffstaffloading: false,
};

export const deleteCoBranch = createAsyncThunk(
  "staffSettingSlice/deleteCoBranch",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/deleteCoBranch.action?coBranchid_id=${data?.coBranchid_id}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteDepts = createAsyncThunk(
  "staffSettingSlice/deleteDepts",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteDepts.action?coDeptid_id=${data?.coDeptid_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteSections = createAsyncThunk(
  "staffSettingSlice/deleteSections",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/hr/deleteSections.action?coSectionid_id=${data?.coSectionid_id}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffStatus = createAsyncThunk(
  "staffSettingSlice/deleteStaffStatus",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffStatus.action?ssId_id=${data?.ssId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffGrade = createAsyncThunk(
  "staffSettingSlice/deleteStaffGrade",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffGrade.action?sgId_id=${data?.sgId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffPosition = createAsyncThunk(
  "staffSettingSlice/deleteStaffPosition",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffPosition.action?spId_id=${data?.spId_id}`)
      .then((res) => res.data);
    return res;
  }
);
export const deleteStaffTerm = createAsyncThunk(
  "staffSettingSlice/deleteStaffTerm",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffTerm.action?stId_id=${data?.stId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffCategory = createAsyncThunk(
  "staffSettingSlice/deleteStaffCategory",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffCategory.action?scId_id=${data?.scId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deletePayrollType = createAsyncThunk(
  "staffSettingSlice/deletePayrollType",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deletePayrollType.action?ptId_id=${data?.ptId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteFiscYear = createAsyncThunk(
  "staffSettingSlice/deleteFiscYear",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteFiscYear.action?fyId_id=${data?.fyId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteFiscPeriod = createAsyncThunk(
  "staffSettingSlice/deleteFiscPeriod",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteFiscPeriod.action?fpId_id=${data?.fpId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteBankBranch = createAsyncThunk(
  "staffSettingSlice/deleteBankBranch",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteBankBranch.action?jbbCode_id=${data?.jbbCode_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deletePrItem = createAsyncThunk(
  "staffSettingSlice/deletePrItem",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deletePrItem.action?piId_id=${data?.piId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteLeaveType = createAsyncThunk(
  "staffSettingSlice/deleteLeaveType",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteLeaveType.action?ltId_id=${data?.ltId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteLeaveDay = createAsyncThunk(
  "staffSettingSlice/deleteLeaveDay",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteLeaveDay.action?ldId_id=${data?.ldId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteLeaveSchedule = createAsyncThunk(
  "staffSettingSlice/deleteLeaveSchedule",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteLeaveSchedule.action?lsId_id=${data?.lsId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffBank = createAsyncThunk(
  "staffSettingSlice/deleteStaffBank",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffBank.action?sbId_id=${data?.sbId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffExempt = createAsyncThunk(
  "staffSettingSlice/deleteStaffExempt",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffExempt.action?seId_id=${data?.seId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deletePrWefDtls = createAsyncThunk(
  "staffSettingSlice/deletePrWefDtls",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deletePrWefDtls.action?wefdId_id=${data?.wefdId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStaffItem = createAsyncThunk(
  "staffSettingSlice/deleteStaffItem",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteStaffItem.action?stId_id=${data?.stId_id}`)
      .then((res) => res.data);
    return res;
  }
);
export const deletePrSlipMsg = createAsyncThunk(
  "staffSettingSlice/deletePrSlipMsg",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deletePrSlipMsg.action?smId_id=${data?.smId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteCasualType = createAsyncThunk(
  "staffSettingSlice/deleteCasualType",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteCasualType.action?casId_id=${data?.casId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteCasualPayment = createAsyncThunk(
  "staffSettingSlice/deleteCasualPayment",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteCasualPayment.action?cpId=${data?.cpId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteAttendance = createAsyncThunk(
  "staffSettingSlice/deleteAttendance",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteAttendance.action?attId=${data?.attId}`)
      .then((res) => res.data);
    return res;
  }
);
export const deleteAttendanceDetail = createAsyncThunk(
  "staffSettingSlice/deleteAttendanceDetail",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteAttendanceDetail.action?attdId_id=${data?.attdId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deletePaymentDetails = createAsyncThunk(
  "staffSettingSlice/deletePaymentDetails",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/py/deletePaymentDetails.action?pdId=${data?.pdId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteCasual = createAsyncThunk(
  "staffSettingSlice/deleteCasual",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteCasual.action?csId=${data?.csId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStoreItem = createAsyncThunk(
  "staffSettingSlice/deleteStoreItem",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/asset/deleteStoreItem.action?stId=${data?.stId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteItemLedger = createAsyncThunk(
  "staffSettingSlice/deleteItemLedger",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/asset/deleteItemLedger.action?ilId=${data?.ilId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteFixedAsset = createAsyncThunk(
  "staffSettingSlice/deleteFixedAsset",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/asset/deleteFixedAsset.action?faId=${data?.faId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteStoreRequest = createAsyncThunk(
  "staffSettingSlice/deleteStoreRequest",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/asset/deleteStoreRequest.action?srId=${data?.srId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteAssetTransfer = createAsyncThunk(
  "staffSettingSlice/deleteAssetTransfer",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/asset/deleteAssetTransfer.action?atId=${data?.atId}`)
      .then((res) => res.data);
    return res;
  }
);

export const staffSettingSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    clearStaffObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(deleteCoBranch.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteCoBranch.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteCoBranch.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteDepts.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteDepts.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteDepts.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteSections.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteSections.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteSections.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffStatus.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffStatus.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffStatus.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffGrade.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffGrade.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffGrade.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffPosition.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffPosition.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffPosition.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffTerm.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffTerm.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffTerm.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffCategory.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffCategory.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffCategory.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deletePayrollType.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deletePayrollType.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deletePayrollType.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteFiscYear.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteFiscYear.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteFiscYear.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteFiscPeriod.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteFiscPeriod.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteFiscPeriod.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteBankBranch.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteBankBranch.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteBankBranch.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deletePrItem.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deletePrItem.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deletePrItem.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteLeaveType.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteLeaveType.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteLeaveType.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteLeaveDay.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteLeaveDay.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteLeaveDay.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteLeaveSchedule.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteLeaveSchedule.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteLeaveSchedule.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffBank.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffBank.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffBank.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffExempt.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffExempt.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffExempt.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deletePrWefDtls.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deletePrWefDtls.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deletePrWefDtls.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStaffItem.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStaffItem.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStaffItem.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deletePrSlipMsg.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deletePrSlipMsg.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deletePrSlipMsg.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteCasualType.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteCasualType.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteCasualType.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteCasualPayment.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteCasualPayment.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteCasualPayment.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteAttendance.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteAttendance.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteAttendance.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteAttendanceDetail.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteAttendanceDetail.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteAttendanceDetail.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deletePaymentDetails.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deletePaymentDetails.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deletePaymentDetails.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteCasual.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteCasual.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteCasual.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStoreItem.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStoreItem.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStoreItem.rejected, (state) => {
        state.staffloading = false;
      }) 
      .addCase(deleteItemLedger.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteItemLedger.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteItemLedger.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteFixedAsset.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteFixedAsset.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteFixedAsset.rejected, (state) => {
        state.staffloading = false;
      })

      .addCase(deleteStoreRequest.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteStoreRequest.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteStoreRequest.rejected, (state) => {
        state.staffloading = false;
      })
      
      .addCase(deleteAssetTransfer.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteAssetTransfer.fulfilled, (state, action) => {
        state.staffloading = false;
      })
      .addCase(deleteAssetTransfer.rejected, (state) => {
        state.staffloading = false;
      })
      
  },
});

export default staffSettingSlice.reducer;
export const {
  setGraduateHeaderObj,
  graduateCleanUp,
  setGraduateListObj,
  setGraduateObj,
  setGradUpload,
  clearStaffObj,
} = staffSettingSlice.actions;
